module.exports = __webpack_public_path__ + "static/media/bg-sun.4c25ccf3.jpg";